import React, {useEffect, useRef, useState} from "react";

import PressCard from "components/AboutUsNew/PressCard";
import Slider from "react-slick";
import styled from "styled-components";

const PressSection = ({pressData = {}}) => {
  const {title = "", articles = []} = pressData;
  const [isMobile, setIsMobile] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef();
  const [settings, setSettings] = useState({
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    swipeToSlide: true,
    variableWidth: false,
    afterChange: (index) => setCurrentSlide(index)
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSettings({
        infinite: true,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        swipeToSlide: true,
        variableWidth: false,
        afterChange: (index) => setCurrentSlide(index)
      });
    }
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) return;

    const elements = document.getElementsByClassName("press-card-slide");
    for (let i = 0; i < elements.length; i++) {
      elements[i].parentNode.style.marginLeft = "1rem";
      elements[i].parentNode.style.marginRight = "1rem";
    }
  }, [isMobile]);

  const handleDiamondClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
      setCurrentSlide(index);
    }
  };

  return (
    <Section>
      <SectionInner>
        <SectionTitle>{title}</SectionTitle>

        {isMobile ? (
          <MobileContainer>
            <Slider ref={sliderRef} {...settings}>
              {articles.map((article, index) => (
                <SlideWrapper key={index} className="press-card-slide">
                  <PressCard {...article} />
                </SlideWrapper>
              ))}
            </Slider>

            <DotsContainer>
              {articles.map((_, index) => (
                <DiamondDot
                  key={index}
                  active={index === currentSlide}
                  onClick={() => handleDiamondClick(index)}
                />
              ))}
            </DotsContainer>
          </MobileContainer>
        ) : (
          <CardsRow>
            {articles.map((article, idx) => (
              <CardWrapper key={idx}>
                <PressCard {...article} />
              </CardWrapper>
            ))}
          </CardsRow>
        )}
      </SectionInner>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  padding: 4.8rem 0 0 0;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 125rem;
    padding: 3.2rem 0 0 0;
  }
`;

const SectionInner = styled.div`
  max-width: 125rem;
  margin: 0 auto;
  width: 85%;

  @media (max-width: 768px) {
    margin-left: 2.22rem;
    padding: 0;
    width:90%;
    max-width: 125rem;
    margin: 0 auto;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'DM Serif Display' ;
  color: #1D1D1F;
  font-size: 5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 3.6rem;

  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0;
    font-size: 2.7rem;
    margin-bottom: 2.66rem;
  }
`;

const MobileContainer = styled.div`
  width: 100%;
  position: relative;
  min-height: 38rem;

  .slick-dots {
    display: none !important;
  }
`;

const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const DiamondDot = styled.div`
  width: 6px;
  height: 6px;
  background: ${props => props.active ? "#6725F4" : "#bdbdbd"};
  transform: rotate(45deg);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: ${props => props.active ? "#6725F4" : "#999"};
    transform: rotate(45deg) scale(1.2);
  }

  &:active {
    transform: rotate(45deg) scale(0.95);
  }
`;

const SlideWrapper = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
`;

const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const CardWrapper = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
`;
export default PressSection;